module.exports = __webpack_public_path__ + "static/media/linkedin.85e14d4b.svg";